import { render, staticRenderFns } from "./activitiesDetail2023qd.vue?vue&type=template&id=cf76226e&scoped=true"
import script from "./activitiesDetail2023qd.vue?vue&type=script&lang=js"
export * from "./activitiesDetail2023qd.vue?vue&type=script&lang=js"
import style0 from "./activitiesDetail2023qd.vue?vue&type=style&index=0&id=cf76226e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf76226e",
  null
  
)

export default component.exports